module.exports = __webpack_public_path__ + "static/media/logo512.a7958246.png";